// An empty region denotes China; opening the root always starts nationwide.
export const DEFAULT_REGION = ''

export function validRegion(value) {
  return typeof value === 'string' && /^(?:\d{2}|\d{4}|\d{6})$/.test(value)
}

export function resolveRegion(explicit) {
  return validRegion(explicit) ? explicit : DEFAULT_REGION
}

export function cityDestination(route, code) {
  // Detail IDs belong to the previous city: return to the new city's home.
  const keepPage = ['Home', 'Map', 'MapMirror', 'Data', 'Search'].includes(route.name)
  return keepPage
    ? { name: route.name, params: { ...route.params, region_id: code }, query: route.query }
    : { name: 'Home', params: { region_id: code } }
}
